<template>

  <table class="table">
    <thead>
    <tr>
      <th v-for="(field, index) in columns" :key="index" :title="field.title">
        {{ field.name }}
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(row, indexRow) in rows" :key="indexRow">
      <td v-for="(field, indexColumn) in row" :key="indexColumn" :title="field.l">
        {{ field.v }}
      </td>
    </tr>
    </tbody>
  </table>

</template>

<script>
  export default {
    name: 'ShowTable',
    props: {
      columns: { required: true, type: Array },
      rows: { required: true, type: Array }
    }
  }
</script>

<style scoped>

</style>